/**
 * Created by anatolij on 05.10.2026
 */

class RoyalLeagueTableRowView {
    constructor(row, options) {
        // eslint-disable-next-line no-constructor-return
        return Prefab.instantiate(bundles.royal_league_window.jsons.royal_league_tablerow_prefab_json, { args: [row, options] });
    }
}
